// extracted by mini-css-extract-plugin
export var cardLayout = "_2a-1";
export var paginationContainer = "_2a-0";